import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActionSheetButton, ActionSheetController, ModalController, NavController } from '@ionic/angular';
import { AirportListComponent } from '../../airport/airport-list/airport-list.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'city-product-card-list',
  templateUrl: './city-product-card-list.component.html',
  styleUrls: ['./city-product-card-list.component.scss'],
})
export class CityProductCardListComponent implements OnInit {
  @Input() productsList: any;
  @Input() noPaging: boolean;
  @Input() currencyCode: any;
  @Output() getNextPage = new EventEmitter<Event>();

  private actionSheetButtonList: ActionSheetButton[] | null = null;
  constructor(
    private navController: NavController,
    private modalController: ModalController,
    private actionSheetController: ActionSheetController,
    private translate: TranslateService,
  ) { }

  ngOnInit() {}

  navigateToProduct(productItem) {
    if (productItem.locationsMap.length === 0) {
      // add toast saying no locations
      return;
    }
    this.actionSheetButtonList = [];
    for (const [key, value] of Object.entries(productItem.locationsMap)) {
      const obj = {
        text: `${value}`,
        role: '',
        handler: () => {
          this.navController.navigateForward([
            'dutyfree/product/',
            productItem.id,
            { loc: key, storeId: productItem.storeId }
          ]);
        },
      };
      if ('Across Airport' === value) {
        obj.role = 'selected';
      }
      this.actionSheetButtonList.push(obj);
    }
    this.openLocationSheet();

  }

  async openLocationSheet() {
    const actionSheetButton: ActionSheetButton = {
      text: this.translate.instant('action_sheet.close'),
      role: 'cancel',
      handler: () => { },
    };
    this.actionSheetButtonList.push(actionSheetButton);
    const actionSheet = await this.actionSheetController.create({
      header: this.translate.instant('action_sheet.filter_by_location'),
      // mode: 'ios',
      cssClass: 'custom-sheet',
      buttons: this.actionSheetButtonList,
    });
    await actionSheet.present();
  }

  navigateToRetailer(retailerItem) {
    if (retailerItem.locationsMap.length === 0) {
      // add toast saying no locations
      return;
    }
    this.actionSheetButtonList = [];
    for (const [key, value] of Object.entries(retailerItem.locationsMap)) {
      const obj = {
        text: `${value}`,
        role: '',
        handler: () => {
          this.navController.navigateForward([
            'dutyfree-detail/',
            retailerItem.id,
            { loc: key }
          ]);
        },
      };
      if ('Across Airport' === value) {
        obj.role = 'selected';
      }
      const actionSheetButton: ActionSheetButton = obj;
      this.actionSheetButtonList.push(actionSheetButton);
    }
    this.openLocationSheet();

  }
}

